import { z } from 'zod';
export const createUploadSchema = z
    .object({
    name: z.string().trim().min(1).max(255),
    size: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
    mimeType: z.string().trim().min(1).max(160)
})
    .strict();
//# sourceMappingURL=uploads.js.map